import { useAccount } from '@contexts/AccountProvider';
import useGetLoan from '@hooks/queries/lending/useGetLoan';
import useGetLoans from '@hooks/queries/lending/useGetLoans';
import useGetCustomerDetails from '@hooks/queries/useGetCustomerDetails';

const useRetrieveAccountLoanDetails = ({
    expand = false,
    enabled = true,
}: {
    expand?: boolean;
    enabled?: boolean;
}) => {
    const { account } = useAccount();
    const {
        data: customerData,
        isLoading: customerLoading,
        isError: isCustomerError,
    } = useGetCustomerDetails({ customerId: account?.customer_id, enabled });
    const {
        data: loansData,
        isLoading: loanListLoading,
        isError: isLoansError,
    } = useGetLoans({ entityId: customerData?.entity?.id, enabled });
    const accountLoan = loansData?.items?.find(
        (loanItem) => account?.account_id === loanItem?.account_id,
    );
    const {
        data,
        isFetching: loanLoading,
        isError: isLoanError,
        refetch,
    } = useGetLoan({ loanId: accountLoan?.loan_id, expand, enabled });

    const isLoading = customerLoading || loanListLoading || loanLoading;
    const isError = isCustomerError || isLoansError || isLoanError;
    return { isLoading, data, isError, refetch };
};

export default useRetrieveAccountLoanDetails;
